export default () => ({
  inventory: [],
  currentInventory: {},
})
